import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"

const COLOR_SELECTIONS = ["#4A3AFF", "#FF718B", "#35B084", "#B17AFF", "#F9B578"]

// 18 shared x-axis labels
const MOCK_LABELS = [
  "Jan '24", "Feb '24", "Mar '24", "Apr '24", "May '24", "Jun '24",
  "Jul '24", "Aug '24", "Sep '24", "Oct '24", "Nov '24", "Dec '24",
  "Jan '25", "Feb '25", "Mar '25", "Apr '25", "May '25", "Jun '25",
]

// Each stage starts at the index where the previous ended (shared boundary point)
const STAGE_STARTS = [0, 3, 6, 9, 12, 15]
const STAGE_VALUES = [
  [295, 380, 350, 235],
  [235, 360, 450, 440],
  [440, 360, 310, 255],
  [255, 290, 320, 280],
  [280, 310, 260, 240],
  [240, 310, 380, 430],
]

// Build null-padded data arrays so all series share the same label axis
const MOCK_SERIES = STAGE_STARTS.map((start, i) => {
  const color = COLOR_SELECTIONS[i % COLOR_SELECTIONS.length]
  const values = STAGE_VALUES[i]
  const data = MOCK_LABELS.map((_, idx) => {
    const pos = idx - start
    return pos >= 0 && pos < values.length ? values[pos] : null
  })
  return { id: `stage-${i}`, color, data, label: `Етап ${i + 1}` }
})

// Pre-build the sx area rules from the series list
const AREA_SX = Object.fromEntries(
  MOCK_SERIES.map((s) => [
    `& .MuiAreaElement-series-${s.id}`,
    { fill: `url(#gradient-${s.id})` },
  ]),
)

function OrdersInTime() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [series, setSeries] = useState([])
  const [filters, setFilters] = useState({ category_id: "" })

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(`analytics/repair-requests?category_id=${filters.category_id}`)
      .then((res) => {
        // TODO: replace with real API data when endpoint is ready
        setLabels(MOCK_LABELS)
        setSeries(MOCK_SERIES)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  function hasAnyData() {
    return labels.length > 0
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilters((prev) => ({ ...prev, [name]: value }))
  }

  return (
    <div className="repair-requests-chart">
      <div className="head" style={{ marginBottom: "15px" }}>
        <h3>Поръчки при изменение на различни компонентни показатели</h3>
      </div>
      <div className="filter-standard">
        <div className="col">
          <input type="search" placeholder="Търсене..." />
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div className="alert info" style={{ marginBottom: 0, width: "100%" }}>
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          series={series.map((s) => ({
            id: s.id,
            label: s.label,
            curve: "natural",
            area: true,
            showMark: false,
            data: s.data,
            color: s.color,
            valueFormatter: (v) => (v == null ? "" : String(v)),
          }))}
          height={400}
          sx={{
            ...AREA_SX,
            "& .MuiLineElement-root": { strokeWidth: 2 },
          }}
          slotProps={{ legend: { hidden: true } }}
        >
          <defs>
            {MOCK_SERIES.map((s) => (
              <linearGradient
                key={s.id}
                id={`gradient-${s.id}`}
                x1="0" y1="0" x2="0" y2="1"
              >
                <stop offset="0%" stopColor={s.color} stopOpacity={0.35} />
                <stop offset="100%" stopColor={s.color} stopOpacity={0.02} />
              </linearGradient>
            ))}
          </defs>
        </LineChart>
      )}
    </div>
  )
}

export default OrdersInTime
